import React from "react";

const NoPermission = () => {
    return (
        <div
            style={{
                minHeight: "80vh",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                fontFamily: "'Segoe UI', sans-serif",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* Soft background blob */}
            <div
                style={{
                    position: "absolute",
                    width: "400px",
                    height: "400px",
                    background: "rgba(47, 127, 123, 0.12)",
                    borderRadius: "50%",
                    filter: "blur(80px)",
                    top: "-80px",
                    left: "-80px",
                    pointerEvents: "none",
                }}
            />
            <div
                style={{
                    position: "absolute",
                    width: "300px",
                    height: "300px",
                    background: "rgba(47, 127, 123, 0.08)",
                    borderRadius: "50%",
                    filter: "blur(60px)",
                    bottom: "-60px",
                    right: "-60px",
                    pointerEvents: "none",
                }}
            />

            {/* Card */}
            <div
                className="text-center"
                style={{
                    background: "#ffffff",
                    borderRadius: "20px",
                    padding: "56px 48px",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.10)",
                    maxWidth: "460px",
                    width: "90%",
                    zIndex: 2,
                    border: "1px solid rgba(47, 127, 123, 0.12)",
                }}
            >
                {/* Lock icon */}
                <div
                    style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #2f7f7b, #4fa39f)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 24px auto",
                        boxShadow: "0 8px 24px rgba(47, 127, 123, 0.35)",
                    }}
                >
                    <i
                        className="fa fa-lock"
                        style={{ fontSize: "32px", color: "#ffffff" }}
                    />
                </div>

                {/* Heading */}
                <h2
                    style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        color: "#1a2e2e",
                        margin: "0 0 10px 0",
                        letterSpacing: "-0.3px",
                    }}
                >
                    No Permission Granted
                </h2>

                {/* Sub-text */}
                <p
                    style={{
                        fontSize: "15px",
                        color: "#6c757d",
                        margin: "0 auto 28px auto",
                        maxWidth: "340px",
                        lineHeight: "1.6",
                    }}
                >
                    You don't have permission to access this page. Please contact your administrator to request access.
                </p>

                {/* Back to Dashboard button */}
                <a
                    href="/admin/dashboard"
                    style={{
                        display: "inline-block",
                        padding: "12px 32px",
                        borderRadius: "30px",
                        background: "linear-gradient(135deg, #2f7f7b, #4fa39f)",
                        color: "#ffffff",
                        fontWeight: "600",
                        fontSize: "14px",
                        textDecoration: "none",
                        boxShadow: "0 6px 20px rgba(47, 127, 123, 0.35)",
                        transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 10px 28px rgba(47, 127, 123, 0.45)";
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 6px 20px rgba(47, 127, 123, 0.35)";
                    }}
                >
                    <i className="fa fa-home me-2" />
                    Back to Dashboard
                </a>
            </div>
        </div>
    );
};

export default NoPermission;
